import React from 'react';

/**
 * Integrations settings page for agents.
 */
export const SettingsIntegrations = () => {
  return (
    <div>
      <h2>Integrations Settings</h2>
    </div>
  );
};
